export function limitString (str = '', limit = 30) {
  return str.length >= limit ? str.substr(0, limit) + '...' : str
}